import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from "@angular/router";
import {CommonModule, DatePipe} from "@angular/common"; // <-- Import CommonModule here
import {HttpClientModule} from '@angular/common/http';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {IonicStorageModule} from '@ionic/storage-angular';
import {AngularSignaturePadModule} from '@almothafar/angular-signature-pad';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

import {RESTService} from "./services/rest.service";
import {StorageService} from "./services/storage.service";
import {GlobalStorageService} from "./services/global-storage.service";
import {UtilsService} from "./services/utils.service";
import {IndexedDB} from "./services/indexed-db.service";
import {APIService} from "./services/api.service";

import {ToggleModule} from "./components/toggle/toggle.module";
import {InputNumberModule} from "./components/input-number/input-number.module";
import {InventoryTableModule} from "./components/inventory-table/inventory-table.module";
import {ReportModule} from "./components/report/report.module";
import {TopToolbarModule} from "./components/top-toolbar/top-toolbar.module";


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule, // <-- Add CommonModule to the imports array
    IonicModule.forRoot({
      mode: 'ios',
      scrollPadding: true,
      scrollAssist: false
    }),
    AppRoutingModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
    AngularSignaturePadModule,
    ToggleModule,
    InputNumberModule,
    InventoryTableModule,
    ReportModule,
    TopToolbarModule
  ],
  providers: [
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    DatePipe,
    RESTService,
    StorageService,
    GlobalStorageService,
    UtilsService,
    IndexedDB,
    APIService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
